import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.routes) },
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.routes').then((m) => m.routes) },
  { path: '**', redirectTo: 'dashboard' }
];
